// libraries
import cn from 'classnames'
import React from 'react'
import Rocketship from 'src/assets/svgs/Rocketship.svg'
import { useTranslate } from 'src/localization/Trns'

import style from './TasksComplete.style'

const TasksComplete: React.FC = () => {
  const translate = useTranslate()

  return (
      <div css={style} className={cn('TasksComplete')}>
        <img
          className={cn('TasksComplete-rocketship')}
          src={Rocketship}
          alt={'rocketship'}
        />
        <div className={cn('TasksComplete-message')}>
          <div className={cn('TasksComplete-message-title')}>
            {translate('You\'re up to date!')}
          </div>
          <div className={cn('TasksComplete-message-body')}>
            {translate('Your transactions are handled and ready for lift off!')}
          </div>
        </div>
      </div>
    )
}

export default TasksComplete
